import CheckList, { Props as CheckListProps } from '@components/atoms/CheckList';
import Typography from '@components/atoms/Typography';

import classes from '@pages/PublicSector/components/ProsAndCons/ProsAndCons.module.scss';

export type Props = {
  title: string;
  description?: string;
  items: {
    id: number;
    text: string;
  }[];
  variant?: CheckListProps['variant'];
};

const CaseStudyCheckList = ({ title, description, variant = 'check', items }: Props): JSX.Element => (
  <div className={classes.wrapper}>
    <div className={classes.sectionTitleWrapper}>
      <Typography variant="h1" renderAs="span" className={classes.sectionTitle}>
        {title}
      </Typography>
    </div>
    <div>
      {description && (
        <Typography variant="h2" renderAs="div" className={classes.sectionDescription}>
          {description}
        </Typography>
      )}
      <CheckList listStyle="unordered" variant={variant}>
        {items.map(({ id, text }) => (
          <CheckList.Item key={id}>{text}</CheckList.Item>
        ))}
      </CheckList>
    </div>
  </div>
);

export default CaseStudyCheckList;
